<template>
  <div :class="className()">
    <label>{{label}}</label>
    <input
      type="text"
      :name="name"
      required=true
      @input="updateText"
      ref="textInput"
      :value="value"
      :aria-label="label"
      :key="`input-${name}`"
    />
    <span class="error-msg" v-if="errors[name]">
      {{errors[name]}}
    </span>
  </div>
</template>

<script>
export default {
  props: ['label', 'name', 'errors', 'value'],
  methods: {
    updateText() {
      let field = this.$refs.textInput
      let value = field.value
      if (field.checkValidity()) {
        field.parentNode.classList.remove('error')
      }
      this.$emit('input', value)
    },
    className() {
      let classes = ['field-group']
      if (this.errors[this.name]) classes.push('error')
      return classes.join(' ')
    }
  }
}
</script>

<style lang="scss">
</style>